import axios from "axios";
import { wardShippingData } from "./xatinh";

// function formatNumber(number, decimalPlaces = 2) {
//     if (number === null || number === undefined) {
//         return number;
//     }

//     const roundedNumber = Number(Number(number).toFixed(decimalPlaces)).toString();

//     const [integerPart, decimalPart] = roundedNumber.split('.');

//     const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

//     return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
// }

function formatNumber(number, decimalPlaces = 2) {
    if (number === null || number === undefined) {
        return number;
    }

    let processedNumber;

    if (Number(number) > 100000) {
        // Làm tròn xuống đến hàng nghìn
        processedNumber = Math.floor(Number(number) / 1000) * 1000;
    } else {
        processedNumber = Number(Number(number).toFixed(decimalPlaces));
    }

    const [integerPart, decimalPart] = processedNumber.toString().split(".");

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
}

const domainIp = 'https://api7.minicorgi.xyz';

const arrCountry = ["Vietnam", "USA", "Japan", "Germany", "France", "India", 'South Korea', 'China', 'Thailand', 'Russia', 'United Kingdom', 'Australia', 'Singapore'];

const domain = "https://api7.minicorgi.xyz";

const refDefault = 'admin@gmail.com';

const login = async (email, password) => {
    try {
        const res = await fetch(`${domain}/auth/login?email=${email}&password=${password}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};

const getUser = async () => {
    const token = localStorage.getItem("token")
    try {
        const res = await fetch(`${domain}/user?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};
const checkLogin = async () => {
    const token = localStorage.getItem("token")
    try {
        const res = await fetch(`${domain}/user?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};
const defaultApi = async () => {
    const token = localStorage.getItem("token")
    const user = localStorage.getItem("user")
    let userparse = ""
    if (user) {
        userparse = JSON.parse(user);

        try {
            const res = await fetch(`${domain}/lightwallet/update?address=${userparse.address}`, {
                method: "GET",
            }).then((res) => res.json());
            return res;
        } catch (err) {
            return false;
        }
    } else {
        return false;
    }

};


const register = async (email) => {
    try {
        const res = await fetch(`${domain}/auth/resend-register-code?email=${email}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};
const verificationEmail = async (email, verificationCode) => {
    try {
        const res = await fetch(`${domain}/auth/submit-code?email=${email}&verificationCode=${verificationCode}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};
const checkUserName = async (username) => {
    try {
        const res = await fetch(`${domain}/auth/check-username?username=${username}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};
const setpass = async (email, username, password, token, ref) => {

    try {
        const res = await fetch(`${domain}/auth/set-password?email=${email}&username=${username}&password=${password}&ref=${ref}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};

const checkRef = async (ref1) => {
    const token = localStorage.getItem("token")
    try {
        const res = await fetch(`${domain}/auth/check-ref?ref=${ref1}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        return false;
    }
};

const payOrderCard = async (order) => {
    try {
        const token = localStorage.getItem("token")

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        const { data } = await axios.post(`${domainIp}/api/orders/card`, order, config);
        return true

    } catch (error) {
        return false
    }
};

// user orders
const ListMyOrdersNone = async () => {
    try {
        let uuid = await localStorage.getItem('uuid')
        if (!uuid) {
            uuid = await generateUUID()
            await localStorage.setItem('uuid', uuid);
        }
        const { data } = await axios.get(`${domainIp}/api/orders/orders-none?uuid=${uuid}`);
        return data
    } catch (error) {
        return
    }
};

// user orders
const listOrdersEvent = async () => {
    try {
        const { data } = await axios.get(`${domainIp}/api/orders/event`);
        return data
    } catch (error) {
        return
    }
};

// const ListMyOrdersNone = () => async (dispatch, getState) => {
//   try {
//     dispatch({ type: ORDER_LIST_MY_REQUEST });

//     let uuid = localStorage.getItem('uuid')
//     if (!uuid) {
//       return []
//     }

//     const { data } = await axios.get(`${domainIp}/api/orders/orders-none?uuid=${uuid}`);

//     dispatch({ type: ORDER_LIST_MY_SUCCESS, payload: data });
//   } catch (error) {
//     const message =
//       error.response && error.response.data.message
//         ? error.response.data.message
//         : error.message;
//     if (message === "Not authorized, token failed") {
//       dispatch(logout());
//     }
//     dispatch({
//       type: ORDER_LIST_MY_FAIL,
//       payload: message,
//     });
//   }
// };

// const ListMyOrdersNone = async () => {
//     try {
//         let uuid = localStorage.getItem('uuid');
//         if (!uuid) {
//             uuid = await generateUUID();  // bỏ await, vì generateUUID có thể là sync
//             localStorage.setItem('uuid', uuid);
//         }
//         const { data } = await axios.get(`${domainIp}/api/orders/orders-none?uuid=${uuid}`);
//         return data;
//     } catch (error) {
//         console.error(error);
//         return null;
//     }
// };




/**
 * Geocode địa chỉ -> lấy toạ độ (lng, lat)
 * @param {string} address
 * @returns {[number, number]} [lng, lat]
 */
async function geocodeAddress(address) {
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(address)}&format=json&limit=1`;
    const res = await axios.get(url, {
        headers: { 'User-Agent': 'Node.js demo' }
    });

    if (res.data.length === 0) throw new Error(`Không tìm thấy địa chỉ: ${address}`);

    const place = res.data[0];
    return [parseFloat(place.lon), parseFloat(place.lat)];
}

/**
 * Tính khoảng cách bằng OSRM demo server
 * @param {[number, number]} fromLngLat [lng, lat]
 * @param {[number, number]} toLngLat [lng, lat]
 * @returns {number} distance in km
 */
async function getDistanceKmOSRM(fromLngLat, toLngLat) {
    const url = `https://router.project-osrm.org/route/v1/driving/${fromLngLat[0]},${fromLngLat[1]};${toLngLat[0]},${toLngLat[1]}?overview=false`;
    const res = await axios.get(url);
    const meters = res.data.routes[0].distance;
    return meters / 1000;
}
const getDistanceKm = async (toAddress) => {
    try {
        // 
        // const toAddress = '1008 Đường Láng, Đống Đa, Hà Nội';

        const fromCoords = await geocodeAddress(fromAddress);
        const toCoords = await geocodeAddress(toAddress);

        console.log(`From coords: ${fromCoords}`);
        console.log(`To coords: ${toCoords}`);

        const distanceKm = await getDistanceKmOSRM(fromCoords, toCoords);
        console.log(`Khoảng cách: ${distanceKm.toFixed(2)} km`);
        return distanceKm ? distanceKm : 999
    } catch (err) {
        return 999
        console.error(err);
    }
};

const fromAddress = '164 Khuất Duy Tiến, Phường Thanh Xuân, Hà Nội';

function tinhGiaShipSoKm(km) {
    const giaCoBan = 15000;   // giá 2km đầu
    const giaMoiKmTiep = 5700;

    if (km <= 2) {
        return giaCoBan;
    } else {
        const soKmTiepTheo = Math.ceil(km - 2); // luôn làm tròn lên km tiếp theo
        let pr = giaCoBan + soKmTiepTheo * giaMoiKmTiep;
        if (pr > 100000) {
            return 100000
        }
        return pr;
    }
}


// const generateUUID = () => {
//     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//         const r = Math.random() * 16 | 0;    // random số 0-15
//         const v = c === 'x' ? r : (r & 0x3 | 0x8);  // bit mask cho variant
//         return v.toString(16);
//     });
// }

function generateUUID() {
    // ObjectId gồm 12 bytes → 24 ký tự hex
    // Đơn giản nhất: dùng thời gian + random để đảm bảo gần giống cách MongoDB tạo
    const timestamp = Math.floor(Date.now() / 1000).toString(16); // 4 bytes
    const random = 'xxxxxxxxxxxxxxxx'.replace(/x/g, () =>
        (Math.floor(Math.random() * 16)).toString(16)
    );
    return timestamp + random;
}
function isMobile(breakpoint = 900) {
    if (typeof window === "undefined") return false; // tránh lỗi SSR
    return window.innerWidth < breakpoint;
}

const rateUsdt = 26500;


const timeFeeRules = [
    { from: "06:30", to: "07:30", percent: [15, 25] },
    { from: "07:30", to: "08:30", percent: [30, 50] },
    { from: "08:30", to: "09:00", percent: [10, 15] },
    { from: "11:00", to: "12:00", percent: [20, 30] },
    { from: "12:00", to: "13:30", percent: [40, 60] },
    { from: "16:30", to: "18:00", percent: [30, 50] },
    { from: "18:00", to: "19:30", percent: [50, 70] },
    { from: "19:30", to: "20:00", percent: [15, 25] },
    { from: "21:30", to: "23:30", percent: [20, 40] },
];

const getTimeIncreasePercent = () => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    for (const rule of timeFeeRules) {
        const [fh, fm] = rule.from.split(":")?.map(Number);
        const [th, tm] = rule.to.split(":")?.map(Number);

        const fromMinutes = fh * 60 + fm;
        const toMinutes = th * 60 + tm;

        if (currentMinutes >= fromMinutes && currentMinutes <= toMinutes) {
            // Lấy mức tăng trung bình giữa min-max (cho dễ áp dụng)
            return (rule.percent[0] + rule.percent[1]) / 2 / 100;
        }
    }

    return 0; // không thuộc khung giờ nào → không tăng phí
};

const countTaxFee = (provinceId, wardCode) => {
    if (provinceId != '11404') {
        return 0
    }
    console.log(provinceId, wardCode);
    const ward = wardShippingData.find(item => item.code == wardCode);
    console.log(ward);
    if (!ward) {
        return 0
    }
    if (!ward.taxFee) {
        return 0
    }
    // return ward.taxFee
    const baseFee = ward.taxFee;
    const timeIncreaseRate = getTimeIncreasePercent(); // ví dụ 0.3 = +30%

    const finalFee = Math.round(baseFee * (1 + timeIncreaseRate));
    return finalFee;
}

function formatSoldCount(number) {
  if (number < 1000) return number.toString();

  if (number < 1_000_000) {
    return (number / 1000).toFixed(number % 1000 === 0 ? 0 : 1) + 'K';
  }

  if (number < 1_000_000_000) {
    return (number / 1_000_000).toFixed(number % 1_000_000 === 0 ? 0 : 1) + 'M';
  }

  return (number / 1_000_000_000).toFixed(1) + 'B';
}

export {
    formatSoldCount,
    countTaxFee,
    listOrdersEvent,
    rateUsdt,
    ListMyOrdersNone,
    generateUUID,
    getDistanceKm,
    tinhGiaShipSoKm,
    payOrderCard,
    arrCountry,
    formatNumber,
    domainIp,

    refDefault,
    checkRef,
    login,
    getUser,
    checkLogin,
    defaultApi,
    register,
    verificationEmail,
    checkUserName,
    setpass,
    isMobile
};